import React from "react";
import {Formik, Field, Form} from "formik";
import {TextField, Loading} from "components/form";
import {transformTranslateFromValues} from "lib/helpers";
import Modal from "components/Modal";
// components

export default function ResetPassword(props) {
   const {show, item} = props;

   return (
      <>
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <Formik
               initialValues={{}}
               onSubmit={async (values, {setSubmitting}) => {
                  await props.submite(transformTranslateFromValues(values), item.id);
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >
               {({isSubmitting, dirty}) => (
                  <Form>
                     <div className="modal-body gap-y-3">
                        <div className="intro-x grid md:grid-cols-2 md:gap-3">
                           <Field
                              placeholder="گذرواژه"
                              label="گذرواژه :"
                              name="password"
                              component={TextField}
                              type={"password"}
                           />
                           <Field
                              placeholder="تکرار گذرواژه"
                              label="تکرار گذرواژه :"
                              name="password_confirmation"
                              type={"password"}
                              component={TextField}
                           />
                        </div>
                     </div>

                     <div className="modal-footer text-right">
                        <button
                           className="btn btn-primary w-20"
                           type="submit"
                           disabled={!!(isSubmitting || !dirty)}
                        >
                           {" "}
                           {isSubmitting ? <Loading/> : "ذخیره"}
                        </button>
                        <button
                           type="button"
                           disabled={isSubmitting}
                           onClick={props.close}
                           className="btn btn-outline-secondary w-20 mr-1 text-white"
                        >
                           انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}
